<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="blue darken-4 white--text"
        >Thêm phân công giảng dạy
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <TeachingAdminNewForm ref="form" :showTeacher="showTeacher" :state="dialog" />
        <v-spacer style="height: 100px" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none" outlined @click="cancel">Huỷ</v-btn>
        <v-btn color="primary text-none" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import get from 'lodash-es/get'
import TeachingAdminNewForm from '../../components/basic/form/TeachingAdminNewForm.vue'

export default {
  components: {
    TeachingAdminNewForm,
  },
  props: {
    state: Boolean,
    showTeacher: Boolean,
  },

  data() {
    return {
      dialog: false,
      loading: false,
      subject: '',
      classData: '',
      grade: null,
      id: '',
    }
  },

  computed: {
    ...mapState('teacher', ['teacher']),
  },

  methods: {
    ...mapActions('teaching', ['createTeaching', 'updateTeaching', 'fetchTeachings']),
    async save() {
      const data = this.$refs.form.getData()
      if (!data) return
      const teaching = await this.fetchTeachings({ class: data.class.id })
      if (teaching.length) {
        const teacher = this.showTeacher === true ? data.teacher : this.teacher
        if (!teaching[0].teacher) {
          try {
            this.$loading.active = true
            await this.updateTeaching({ id: teaching[0].id, teacher: teacher.id })
            this.$alert.success('Cập nhật thành công')
            this.dialog = false
            this.$emit('done')
          } catch (error) {
            console.error(error)
            this.$alert.updateError(error)
          } finally {
            this.$loading.active = false
          }
          return
        }
        this.$dialog.confirm({
          title: 'Lớp đã có giáo viên chủ nhiệm',
          text: `Giáo viên ${teaching[0].teacher.name} đã chủ nhiệm lớp này. Bạn có muốn tiếp tục thay đổi giáo viên chủ nhiệm không?`,
          okText: 'Có',
          cancelText: 'Hủy',
          done: async () => {
            try {
              this.$loading.active = true
              await this.updateTeaching({ id: teaching[0].id, teacher: teacher.id })
              this.$alert.success('Cập nhật thành công')
              this.dialog = false
              this.$emit('done')
            } catch (error) {
              console.error(error)
              this.$alert.updateError(error)
            } finally {
              this.$loading.active = false
            }
          },
        })
      }
    },
    cancel() {
      this.dialog = false
    },

    onFilterChanged() {
      this.$emit('onFilterChanged', {
        id: this.id,
        grade: this.grade,
        classData: this.classData,
        subject: this.subject.id,
      })
    },
    gradeChanged(grade) {
      if (get(this.grade, 'academicLevel') !== get(grade, 'academicLevel')) {
        this.classData = null
      }
      this.grade = grade
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
